import * as Styled from './styled'
import { Props } from './interfaces'
import { Title, Error, Success } from './sections'

function Popover({ title, messages }: Props) {
  return (
    <Styled.Container role="dialog">
      <Title>{title}</Title>
      {messages.map(({ text, isSuccess }) => {
        const Component = isSuccess ? Success : Error

        return <Component key={text}>{text}</Component>
      })}
    </Styled.Container>
  )
}

export default Popover
